import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(( ) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '225px 1fr'
  },
  sidebarMenu: {
    padding: '20px 20px 20px 0',
    width: '100%',
  },
  sidebarItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '15px',
    cursor: 'pointer',
    color:'#4A4A4A',
    paddingLeft: '25px',
    marginBottom: '22px',
    textDecoration: 'none',
  },
  sidebarItemBorder: {
    borderLeft: '3px solid #00AAE9',
  },
  sidebarItemText: {
    margin: 0
  },
  sidebarSubitems: {
    paddingLeft: '58px'
  },
  sidebarIcon: {
    marginRight: '5px',
    color:'#00AAE9',
  },
  allPages: {
    borderLeft: '1px solid #CFDDE2',
    paddingLeft: '20px',
    margin: 0,
    width: '100%',
  },
  submenuItem: {
    fontSize: '14px',
    cursor: 'pointer',
    margin: '0 0 16px 0',
    fontWeight: 600,
  },
  lighText: {
    color: '#a5a5a5'
  },
  darkText: {
    color: '#4a4a4a'
  },
  hideSubmenu: {
    display: 'none'
  },
  pagination: {
    color: 'green',
    '& button': {
      color: '#C4C4C4'
    },
    '& div': {
      color: '#C4C4C4'
    }  
  },
  documentsWrapper: {
    marginTop: '20px'
  },
  documentsTable: {
    display: 'grid',
    gridTemplateColumns: 'minmax(220px, 1fr) minmax(350px, 1fr) minmax(140px, 1fr)  minmax(270px, 1fr)',
    marginRight: '20px',
    '& thead, & tbody, & tr': {
      display: 'contents'
    }
  },
  columnOptionsWrapper: {
    display: 'grid',
    gridTemplateColumns: 'minmax(220px, 1fr) minmax(350px, 1fr) minmax(140px, 1fr)  minmax(270px, 1fr)',
    padding: '0 41px 0 20px',
    borderTop: '1px solid #CFDDE2',
    borderBottom: '1px solid #CFDDE2',
    margin: ' 0 20px 4px 0',
  },
  menuArrowIcon: {
    width: '12px',
    marginLeft: '5px',
  },  
  rotateArrowIcon: {
    transform: 'rotate(180deg)',
  },
  columnMenuItem: {
    color: '#4A4A4A',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    borderTop: '1px solid #CFDDE2',
    borderBottom: '1px solid #CFDDE2',
    margin: '0',
    padding: '8px 0',
    '&:first-child': {
      paddingLeft: '20px',
    },
    '&:hover span span': {
      backgroundColor: '#E2E2E2',
    },
    '&:hover span.active span': {
      backgroundColor: '#00AAE9'
    },
  },
  resizeHandle: {
    position: 'absolute',
    right: '0',
    cursor: 'col-resize',
    height: '30px',
    width: '1px',
    backgroundColor: 'transparent',
    padding: '0 15px',
  },
  resizeHandleBar: {
    display: 'block',
    width: '5px',
    height: '30px',
    backgroundColor: 'transparent',
  },
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
